import { ResetPasswordSetUserPasswordNamespace } from '@core/models/client';

export namespace ResetPasswordSetUserPasswordApiNamespace {
  export class IN {
    passwordrequestreference: string = '';
    password: string = '';
    //captchaToken: string = '';
    constructor(input: ResetPasswordSetUserPasswordNamespace.IN) {
      this.password = input.password;
      this.passwordrequestreference = input.token;
      //this.captchaToken = input.recaptchaToken;
    }
  }

  export class OUT {
    // recoverPasswordKey: string = '';
  }
}
